import { createComponent } from '@mtfe/sweet';
import Toast from '../Toast/script.js';
import { common, dom } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const domId = createUniqueId();
const showModalLogin = () => {
    dom.$id(domId).style.display = 'flex';
};
const hideModalLogin = () => {
    dom.$id(domId).style.display = 'none';
};

/**
 * @param {Object} props 参数
 * @returns
 */
const LoginModal = (props = {}) => {
    const { loadLogin, loginSuccessCb } = props;
    if (!loadLogin) {
        throw new Error('Params loadLogin must be required!');
    }

    loadLogin('loignContainer', style.extraClass, {
        loginCompleteHandler: (info) => {
            if (info.user) {
                Toast({ message: '登录成功', position: 'center' });
                setTimeout(() => {
                    hideModalLogin();
                    loginSuccessCb && loginSuccessCb(info);
                }, 500);
            } else {
                Toast({ message: '登录失败，请稍后重试', position: 'center' });
            }
        },
    });

    const data = {
        domId,
    };
    const events = {
        close: () => {
            hideModalLogin();
            return false;
        },
    };
    const component = createComponent(tpl, { data, style, props }, events);

    return component;
};

export default LoginModal;
export { showModalLogin, hideModalLogin };
